import { store } from "@store/store";
import { fetchConfigAndRedirect } from "../fetchConfigRedirect";
import { RedirectToDefaultPaymentOrAutopay } from "../redirectToDefaultPaymentOrAutopay";

export const redirectionToCheckoutOrNextNode = async (args: any) => {
  const state = store?.getState();
  const normalisedConfig = state?.configuration?.normalisedConfig;
  
  const skipCheckout = normalisedConfig?.autopay_modal?.props?.skipCheckout;
  if (skipCheckout === true) {
    const redirectArgs = {
      modal_id: "autopay_modal",
      redirect_data: args?.data || args || {}
    };
    await RedirectToDefaultPaymentOrAutopay(redirectArgs);
  } else {
    await fetchConfigAndRedirect(args);
  }
};

export default redirectionToCheckoutOrNextNode;


